import "./journals-supervision-registration.scss";
import { Fragment } from "react";
import { useQuery } from "@tanstack/react-query";
import { Col, Row, Typography, Spin } from "antd";
import { journalsQueries } from "@/entities/journal";
import { useCoordinator } from "@/shared/lib/hooks";
import { fallbackString, formatDate } from "@/shared/utils";

const { Title } = Typography;

interface IJournalsSupervisionRegistrationProps {
  titleData: any;
}

export const JournalsSupervisionRegistration = ({
  titleData,
}: IJournalsSupervisionRegistrationProps) => {
  const { titleId } = useCoordinator();

  const { data, isPending } = useQuery(
    journalsQueries.getTitleDetails({
      mainJournalId: titleData.mainJournal?.mainJournalId || "",
      registrationInfoId:
        titleData.mainJournal?.titleJournal?.registrationInfoId || "",
      titleId,
    }),
  );

  const registry = data?.buildingInfo?.supervisoryAuthorityRegistryRecord;
  const signedPart = registry?.supervisoryAuthorityRegistryRecordSignedPart;
  const rep = signedPart?.supervisoryAuthorityRepresentative;

  const fullName = [rep?.lastName, rep?.firstName, rep?.middleName]
    .filter(Boolean)
    .join(" ");

  const tableFirst = [
    {
      id: 1,
      title: "Регистрационный номер",
      info: fallbackString(signedPart?.journalID),
    },
    {
      id: 2,
      title: "Дата регистрации",
      info: fallbackString(formatDate(signedPart?.registrationDate)),
    },
  ];

  const tableSecond = [
    {
      id: 3,
      title: "ФИО",
      info: fallbackString(fullName),
    },
    {
      id: 4,
      title: "Должность",
      info: fallbackString(rep?.position),
    },
  ];

  if (!signedPart) {
    return (
      <div className="table-container">
        <Title level={4}>
          Регистрационная надпись органа государственного строительного надзора
        </Title>
        <div className="journal-empty-text">
          Сведения не присланы
        </div>
      </div>
    );
  }

  return (
    <Spin spinning={isPending}>
      <div className="table-container table-container-registration">
        <Title level={4}>
          Регистрационная надпись органа государственного строительного надзора
        </Title>

        <Row gutter={[16, 16]}>
          {tableFirst.map(({ id, title, info }) => (
            <Fragment key={id}>
              <Col span={8} style={{ color: "#888" }}>
                {title}
              </Col>
              <Col span={16}>{info}</Col>
            </Fragment>
          ))}
        </Row>

        <Title level={5} style={{ marginTop: 24 }}>
          Представитель Госстройнадзора, внёсший регистрационную запись
        </Title>

        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          {tableSecond.map(({ id, title, info }) => (
            <Fragment key={id}>
              <Col span={8} style={{ color: "#888" }}>
                {title}
              </Col>
              <Col span={16}>{info}</Col>
            </Fragment>
          ))}
        </Row>
        <div className="table-container-registration-signature">
          <div className="table-container-registration-signature-title">
            Подпись
          </div>
          <div className="table-container-registration-signature-signature">
            Доверевнность{" "}
            {fallbackString(registry?.supervisoryAuthoritySignature?.mchdId)}
          </div>
        </div>
      </div>
    </Spin>
  );
};
